angular.module('leanlaw').controller('AddStandardCtrl', ['$scope', 'company', '$state', 'userService', function ($scope, company, $state, userService) {
  $scope.company = {};
  activate();
  $scope.saveStandard = function () {
    $scope.data.fixed = angular.copy($scope.matter.billing.fixed);
    if (!$scope.company.settings.fixedFees) {
      $scope.company.settings.fixedFees = [];
    }
    $scope.company.settings.fixedFees.push($scope.data.fixed);
    console.log('updating: ', $scope.company.settings.fixedFees);
    company.update({
      settings: {
        fixedFees: $scope.company.settings.fixedFees
      }
    }).then(company => {
      $state.go('^');
    }).catch(err => {
      let reason = "";
      if (err && err.body && err.body.message) {
        reason += `: ${err.body.message}`;
      }
      $scope.message = `Failed to save fixed fee${reason}`;
    });
  };

  ///////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.company = me.company;
    });
  }
}]);